import Base from './base';

class StorageModel extends Base {
    constructor(options) {
        options.methods = options.methods || {};

        super(options);

        var _ = this;

        _.storage = options.storage || {};

        for (var key in options.methods) {
            _[key] = options.methods[key];
        }

        _.perInstanceStores = {};
    }

    _getStore(store, item, key) {
        var _ = this;

        if (typeof store === 'function' && typeof item === 'object' && item.id) {
            if (typeof _.perInstanceStores[key] === 'object') {
                store = _.perInstanceStores[key];
            } else {
                store = store.call(item);

                if (typeof store === 'object' && typeof store._connect === 'function') {
                    store._connect(_, item.id);
                    _.perInstanceStores[key] = store;
                }
            }
        }

        return store;
    }

    _eachStore(method, item, args, success) {
        var _ = this,
            storage = _.storage,
            promises = [],
            store;

        for (var key in storage) {
            store = _._getStore(storage[key], item, key + (item ? '-' + item.id : ''));

            if (typeof store === 'object' && typeof store[method] === 'function') {
                promises.push(
                    store[method].apply(store, args)
                );
            }
        }

        return Promise.all(promises).then(success);
    }

    query(data) {
        var _ = this;

        _._eachStore('query', data, []);

        return Base.prototype.query.call(_);
    }

    save(item) {
        var _ = this,
            changes = item.changes();

        Base.prototype.save.call(_, item);

        _._eachStore('save', item, [item, changes]);

        return item;
    }

    destroy(item) {
        var _ = this;

        Base.prototype.destroy.call(_, item);

        _._eachStore('destroy', item, [item]);

        return item;
    }
}

export default StorageModel;
